import React from 'react';
import Tooltip from '@components/tooltip';
import DOMPurify from 'dompurify';
import { fixHangingPrepositions } from '../../utils/unhangPrepositions';
import * as styles from './Icon.scss';

const getSanitizedHtml = tooltipText =>
  DOMPurify.sanitize(fixHangingPrepositions(tooltipText), { USE_PROFILES: { html: true } });

const getTooltipContent = (complexTooltip, icon) => {
  if (complexTooltip) {
    return (
      <React.Fragment>
        {icon.tooltipTitle && (
          <div
            className={styles.tooltipTitle}
            dangerouslySetInnerHTML={{ __html: getSanitizedHtml(icon.tooltipTitle) }}
          />
        )}
        {icon.tooltip && <div dangerouslySetInnerHTML={{ __html: getSanitizedHtml(icon.tooltip) }} />}
      </React.Fragment>
    );
  }

  return (
    <div dangerouslySetInnerHTML={{ __html: getSanitizedHtml(icon.tooltip) }} />
  );
};

const Icon = (props) => {
  const {
    icon,
    url,
    classname,
    onClick,
    complexTooltip,
  } = props;

  if (!icon) {
    return null;
  }

  return (
    <Tooltip
      place="top"
      effect="solid"
      content={getTooltipContent(complexTooltip, icon)}
      maxWidth={216}
    >
      <a
        href={url}
        target="_blank"
        onClick={onClick || (e => e.stopPropagation())}
        rel="noreferrer"
      >
        <img
          src={icon.url}
          alt="icon"
          className={classname}
        />
      </a>
    </Tooltip>
  );
};

export default Icon;
